"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = require("@formily/react");
var schema_1 = require("../shared/schema");
var shared_1 = require("@formily/shared");
var react_eva_1 = require("react-eva");
var actions_1 = require("../shared/actions");
var registry_1 = require("../shared/registry");
var connect_1 = require("../shared/connect");
var visible_1 = require("../linkages/visible");
var schema_2 = require("../linkages/schema");
var state_1 = require("../linkages/state");
var lowercaseKeys = function (obj) {
    var result = {};
    shared_1.each(obj, function (value, key) {
        result[shared_1.lowercase(key)] = value;
    });
    return result;
};
var ConnectedComponent = Symbol.for('connected');
var transformComponents = function (components) {
    var fieldComponents = {};
    var virtualFieldComponents = {};
    shared_1.each(components, function (component, name) {
        if (!shared_1.isFn(component) && !component['styledComponentId'])
            fieldComponents[name] = function () {
                return react_1.createElement('div', {}, 'Can not found any component.');
            };
        if (component['__ALREADY_CONNECTED__'] || component['isFieldComponent']) {
            fieldComponents[name] = component;
        }
        else if (component['__VIRTUAL_BOX__']) {
            virtualFieldComponents[component['__VIRTUAL_BOX__']['key']] =
                component['__VIRTUAL_BOX__']['component'];
        }
        else if (component['isVirtualFieldComponent']) {
            virtualFieldComponents[name] = component;
        }
        else if (!component[ConnectedComponent]) {
            component[ConnectedComponent] = connect_1.connect()(component);
            fieldComponents[name] = component[ConnectedComponent];
        }
        else {
            fieldComponents[name] = component[ConnectedComponent];
        }
    });
    return { fieldComponents: fieldComponents, virtualFieldComponents: virtualFieldComponents };
};
var useInternalSchemaForm = function (props) {
    var fields = props.fields, virtualFields = props.virtualFields, components = props.components, formComponent = props.formComponent, formItemComponent = props.formItemComponent, componentPropsInterceptor = props.componentPropsInterceptor, propsSchema = props.schema, defaultValue = props.defaultValue, value = props.value, initialValues = props.initialValues, actions = props.actions, effects = props.effects, onChange = props.onChange, onSubmit = props.onSubmit, onReset = props.onReset, onValidateFailed = props.onValidateFailed, useDirty = props.useDirty, children = props.children, expressionScope = props.expressionScope, form = props.form, editable = props.editable, validateFirst = props.validateFirst, formComponentProps = __rest(props, ["fields", "virtualFields", "components", "formComponent", "formItemComponent", "componentPropsInterceptor", "schema", "defaultValue", "value", "initialValues", "actions", "effects", "onChange", "onSubmit", "onReset", "onValidateFailed", "useDirty", "children", "expressionScope", "form", "editable", "validateFirst"]);
    var implementActions = react_eva_1.useEva({
        actions: actions
    }).implementActions;
    var schema = react_1.useMemo(function () {
        var result = new schema_1.Schema(propsSchema);
        implementActions({
            getSchema: shared_1.deprecate(function () { return result; }, 'Please use the getFormSchema.'),
            getFormSchema: function () { return result; }
        });
        return result;
    }, [propsSchema]);
    var registry = registry_1.getRegistry();
    var _a = transformComponents(components), fieldComponents = _a.fieldComponents, virtualFieldComponents = _a.virtualFieldComponents;
    return {
        form: react_2.useForm(__assign(__assign({}, props), { effects: function ($, actions) {
                visible_1.useValueVisibleLinkageEffect(expressionScope);
                schema_2.useValueSchemaLinkageEffect(expressionScope);
                state_1.useValueStateLinkageEffect(expressionScope);
                if (shared_1.isFn(effects)) {
                    effects($, actions);
                }
            } })),
        formComponentProps: __assign(__assign({}, formComponentProps), schema.getExtendsComponentProps()),
        fields: lowercaseKeys(__assign(__assign(__assign({}, registry.fields), fields), fieldComponents)),
        virtualFields: lowercaseKeys(__assign(__assign(__assign({}, registry.virtualFields), virtualFields), virtualFieldComponents)),
        formComponent: formComponent ? formComponent : registry.formComponent,
        formItemComponent: formItemComponent
            ? formItemComponent
            : registry.formItemComponent,
        schema: schema,
        componentPropsInterceptor: componentPropsInterceptor,
        children: children
    };
};
exports.useSchemaForm = function (props) {
    var actionsRef = react_1.useRef(null);
    actionsRef.current =
        actionsRef.current || props.actions || actions_1.createSchemaFormActions();
    return useInternalSchemaForm(__assign(__assign({}, props), { actions: actionsRef.current }));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/hooks/useSchemaForm.js
// module id = 1028
// module chunks = 0